import './ContactSupport.scss';
import { useEffect } from 'react';
import { show } from '@intercom/messenger-js-sdk';
import { CSM_MEMBERS } from 'src/constants';
import { useAppSelector } from '@/store/hooks/useAppSelector';
import { getLoggedInUser } from '@/store/account/selector';
import CsmCard from '@/pages/ResellerDashboard/ResellerReceptionist/CsmCard';
import Header from '@/components/Header';
import { CustomerServiceOutlined } from '@ant-design/icons';

export const ContactSupport = () => {
	useEffect(() => {
		show();
	}, []);

	const loggedInUser = useAppSelector(getLoggedInUser);
	const csmMember =
		CSM_MEMBERS.find((member) => member.email === loggedInUser?.csm) || CSM_MEMBERS[0];

	return (
		<>
			<Header
				icon={<CustomerServiceOutlined />}
				title="Get Live Help"
				description="Get in touch with Support in just minutes! 👇"
				debrand={loggedInUser.resellerClient}
			/>
			<CsmCard
				avatarUrl={csmMember.imageUrl || ''}
				name={csmMember.name || 'N/A'}
				email={csmMember.email || 'N/A'}
				description="As your Customer Success Manager, I'm here to help you get the most out of our platform. Feel free to book a call with me to discuss any questions or concerns you may have."
				calendlyLink={csmMember.calendlyLink}
			/>
		</>
	);
};
